import { ChangeEvent, FunctionComponent, useCallback, useState } from 'react'
import { MdPlayArrow } from 'react-icons/md'
import Button from 'shared/components/Button'

import * as Yup from 'yup'

import iconPhone from 'shared/assets/icons/icon-telefone.png'
import Form, { IProps as FormProps } from 'shared/components/Form'
import Input from 'shared/components/Input'
import Page from 'shared/components/Page'
import { colors } from 'shared/styles/colors'
import { phoneMask } from 'shared/utils/formatters'

import { steps } from '../../'
import Sms from '../Sms'
import { IPhoneProps } from './PhoneComponent.types'
import { Container, ContainerForm, ContainerText } from './styles'

const Phone: FunctionComponent<IPhoneProps> = ({
  setSelectedStep,
  sendPin,
  verifyPin,
  verifyPhoneAndCnpj,
}) => {
  const [phone] = useState(() => {
    if (localStorage.getItem('@TMov:ChangeGestorPhone')) {
      return localStorage.getItem('@TMov:ChangeGestorPhone')
    }

    return ''
  })
  const [phoneOk, setPhoneOk] = useState(() => {
    if (localStorage.getItem('@TMov:ChangeGestorPhone')) {
      return true
    }

    return false
  })
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [viewSms, setViewSms] = useState(false)

  const handleSubmit = useCallback(
    async (values: FormProps['values']) => {
      setLoading(true)
      setErrorMessage('')

      try {
        await verifyPhoneAndCnpj.execute({
          phone: values.phone,
        })
        await sendPin.execute({ phone: values.phone })

        localStorage.setItem('@TMov:ChangeGestorPhone', values.phone)

        setViewSms(true)
      } catch (e: unknown) {
        if (e instanceof Error) {
          setErrorMessage(e.message)
        } else {
          setErrorMessage('Erro ao tentar enviar o pin')
        }
        setLoading(false)
      }
    },
    [sendPin, verifyPhoneAndCnpj],
  )

  const handleChange = useCallback(async (e: ChangeEvent<HTMLInputElement>) => {
    setPhoneOk(false)

    if (!e.target.value) return

    try {
      const schema = Yup.object().shape({
        phone: Yup.string()
          .required()
          .matches(/\(\d{2,}\) \d{4,}-\d{4}/g),
      })

      await schema.validate(
        {
          phone: e.target.value,
        },
        {
          abortEarly: false,
        },
      )

      setPhoneOk(true)
    } catch (e) {
      setPhoneOk(false)
    }
  }, [])

  if (viewSms) {
    return (
      <Sms
        setSelectedStep={setSelectedStep}
        sendPin={sendPin}
        verifyPin={verifyPin}
      />
    )
  }

  return (
    <Page
      icon={iconPhone}
      title="Legal!<br />Agora precisamos do número do seu celular:"
      goBackTo={() => {
        setSelectedStep(steps.EmailConfirm)
      }}
    >
      <Container>
        <Form
          onSubmit={handleSubmit}
          initialValues={{ phone }}
          validationSchema={() => ({
            phone: Yup.string().required(),
          })}
        >
          {formControl => (
            <ContainerForm>
              <ContainerText>
                <Input
                  placeholder="DDD + Número"
                  name="phone"
                  formControl={formControl}
                  errorMessage={errorMessage}
                  mask={value => phoneMask(value)}
                  onChange={handleChange}
                  maxLength={15}
                />
              </ContainerText>

              <Button
                color={phoneOk ? colors.green : colors.grayLight}
                disabled={!phoneOk || loading}
                loading={loading}
                type="submit"
                onClick={formControl.handleSubmit}
              >
                <MdPlayArrow /> Próximo
              </Button>
            </ContainerForm>
          )}
        </Form>
      </Container>
    </Page>
  )
}

export default Phone
